import * as React from 'react';
import styled from 'styled-components';

import { useParams } from 'react-router';
import { STATUS_NYBYGG } from '../../../client/__graphql__/queries/getStatusSold';
import { Container } from './Container';
import { StatusItem } from './StatusItem';
import { useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { AssignmentType, Estate, useProjectStatisticsQuery } from '../../__types__/generated/cluster';
import { env } from '../../__config__/env';
import { client } from '../../../client/__graphql__/clusterClient';

const StatusWrapperStyle = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 20px;
  padding-bottom: 3em;

  @media all and (max-width: 750px) {
    grid-template-columns: 1fr 1fr;
  }

  @media all and (max-width: 620px) {
    grid-template-columns: 1fr;
    grid-row-gap: 35px;
  }

  @media all and (max-width: 450px) {
    padding: 2em 0 0 0;
    grid-row-gap: 20px;
  }
`;

interface Status {
  projects: number;
  units_for_sale: number;
  units_sold: number;
}

export const StatusWrapper: React.FC = () => {
  const [data, SetData] = React.useState<Status>({ projects: 0, units_for_sale: 0, units_sold: 0 });
  const params = useParams<{ urltag: string }>();

  useProjectStatisticsQuery({
    skip: !params.urltag,
    client: client,
    fetchPolicy: 'network-only',
    variables: {
      input: {
        brandId: env.BRAND_ID
      },
      filter: {
        aggregations: true,
        assignmentTypes: [AssignmentType.NewDevelopment, AssignmentType.NewDevelopmentCommercial, AssignmentType.NewDevelopmentLeisure],
        tags: [params?.urltag],
        isProjectMaster: true,
        published: true,
        pagination: {
          limit: 200
        }
      }
    },
    onCompleted: (data) => {
      const statistics = data?.search?.estate?.aggregations?.projectStatistics;
      if (statistics?.projectCount ?? 0 > 0) {
        SetData({
          projects: statistics?.projectCount ?? 0,
          units_for_sale: statistics?.unitsAvailable ?? 0,
          units_sold: statistics?.unitsSold ?? 0
        });
      }
    }
  });

  return (
    <Container>
      <StatusWrapperStyle>
        <StatusItem count={data.projects} description="Prosjekter til salgs" />
        <StatusItem count={data.units_for_sale} description="Leiligheter til salgs" />
        <StatusItem count={data.units_sold} description="Solgte enheter, siste tre måneder" />
      </StatusWrapperStyle>
    </Container>
  );
};
